<template>
  <template v-if="draft">
    <component
      :is="components[draft.type]"
      :action="draft"
      @close="onBulkClose"
      @success="onBulkSuccess"
    />
  </template>
</template>

<script setup lang="ts">
import { toRef } from "vue";

import { useStore } from "@/store/stores/bulk-actions";

import components from "./lazy-register";

const store = useStore();
const draft = toRef(store, "_draft");

const onBulkClose = () => {
  draft.value = undefined;

  for (const listener of store._closeWatchers) {
    listener();
  }
};

const onBulkSuccess = () => {
  for (const listener of store._doneWatchers) {
    listener();
  }
};
</script>
